import axios from 'axios';

const api = axios.create({
    baseURL: 'https://kitchen.appgenie.site/genie-kitchen/'
});

export default api;